(() => {
  'use strict';
  if (customElements.get('wv-guarantee')) return;
  const catalog = JSON.parse(document.getElementById('wv-guarantee-catalog').textContent);
  const families = {'500':'500', '500pro':'500', '500proaccore':'500', b500:'500', bk215plus:'bk', b215plus:'bk', ev3600:'ev'};
  const clone = id => document.getElementById(id)?.content.cloneNode(true);

  class WVGuarantee extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-guarantee-content]');
      this.ids = new Set(this.dataset.variantIds.split(','));
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.scope = this.closest('[data-wv-500-series], [data-wv-configurator], [data-wv-pdp], .product-section');
      if(this.hasAttribute('data-configuration')) {
        this.scope?.addEventListener('wv:guarantee-selection', () => this.sync(), options);
      } else {
        document.addEventListener('variant:change', event => {
          const id = String(event.detail?.variant?.id || '');
          if(this.ids.has(id)) { this.dataset.variantId=id; this.sync(); }
        }, options);
        this.scope?.addEventListener('change', event => {
          if(event.target.matches('[data-wv-addon]')) this.sync();
        }, options);
      }
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
    sync() {
      let items=[{id:this.dataset.variantId,quantity:1}];
      if(this.hasAttribute('data-configuration') && this.scope?.dataset.guaranteeItems) {
        try { items=JSON.parse(this.scope.dataset.guaranteeItems); } catch { return; }
      } else {
        const extra=this.scope?.querySelector('[data-wv-addon]:checked');
        if(extra) items.push({id:extra.dataset.variantId,quantity:1});
      }
      const models={};
      for(const item of items) {
        const quantity=Number(item.quantity);
        if(!Number.isSafeInteger(quantity)||quantity<1) continue;
        for(const [model,count] of Object.entries(catalog[String(item.id)]||{})) {
          models[model]=count===null||models[model]===null ? null : (models[model]||0)+count*quantity;
        }
      }
      this.hidden=Object.keys(models).length===0;
      const key=JSON.stringify(models);
      if(this.state===key) return;
      this.state=key;
      const openFamilies=new Set([...this.content.querySelectorAll('.wv-guarantee__family')].filter(el=>el.querySelector('details')?.open).map(el=>el.dataset.guaranteeFamily));
      const fragment=document.createDocumentFragment();
      for(const family of [...new Set(Object.keys(models).map(model=>families[model]))]) {
        for(const [model,count] of Object.entries(models).filter(([model])=>families[model]===family)) {
          const row=clone('wv-guarantee-model-'+model);
          if(!row) continue;
          row.querySelector('[data-guarantee-quantity]').textContent=count===null?'':count+' \u00d7 ';
          fragment.append(row);
        }
        const terms=clone('wv-guarantee-family-'+family);
        if(terms) {
          if(openFamilies.has(family)) terms.querySelector('details').open=true;
          fragment.append(terms);
        }
      }
      this.content.replaceChildren(fragment);
    }
  }
  customElements.define('wv-guarantee',WVGuarantee);

  const dialog=document.getElementById('WVGuaranteeDialog');
  let opener;
  document.addEventListener('click',event=>{
    const link=event.target.closest?.('[data-wv-guarantee-open]');
    if(!link||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||!dialog.showModal) return;
    event.preventDefault();
    opener=link;
    dialog.querySelector('h2').textContent=link.dataset.guaranteeTitle;
    const image=dialog.querySelector('[data-wv-guarantee-image]');
    image.alt=link.dataset.guaranteeTitle;
    image.src=link.href;
    dialog.showModal();
    dialog.querySelector('button').focus();
  });
  dialog.querySelector('[data-wv-guarantee-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{ if(opener?.isConnected) opener.focus({preventScroll:true}); });
  dialog.addEventListener('keydown',event=>{ if(event.key==='Escape'||event.key==='Tab') event.stopPropagation(); });
})();
